module.exports = __webpack_public_path__ + "img/A58A0784.1df15562.jpg";